













































import { LibriSearchRequest, Libro } from "@/data/models/biblioteca.model";
import { BibliotecaService } from "@/data/services/biblioteca.service";
import BibliotecaSearch from "@/packages/biblioteca/BibliotecaSearch.vue";
import BibliotecaTable from "@/packages/biblioteca/BibliotecaTable.vue";
import LibroDetailCard from "@/packages/biblioteca/LibroDetailCard.vue";
import { Page } from "yellowfin-ui-lib";
import { Component, Inject, Vue } from "vue-property-decorator";
import packageInfo from "../../../package.json";

@Component({
  components: {
    BibliotecaSearch,
    BibliotecaTable,
    LibroDetailCard,
  },
})
export default class BibliotecaCompact extends Vue {
  @Inject("BibliotecaService") bibliotecaService!: BibliotecaService;

  view: "list" | "detail" = "list";

  data: Libro[] = [];
  loading = false;
  hasSearched = false;
  selectedLibro?: Libro;

  searchparam: LibriSearchRequest = new LibriSearchRequest();
  page: Page = new Page(20);

  search() {
    this.loading = true;
    this.hasSearched = false;
    const searchreq = this.bibliotecaService.search(this.searchparam, this.page);
    const countreq = this.bibliotecaService.searchCount(this.searchparam);
    Promise.all([searchreq, countreq])
      .then((results) => {
        this.data = results[0];
        this.page.setTotal(results[1].cnt || 0);
      })
      .finally(() => {
        this.loading = false;
        this.hasSearched = true;
      });
  }

  onSearchChange(searchparam: LibriSearchRequest) {
    this.searchparam = searchparam;
    this.page.setPageNumber(0);
    this.search();
  }

  onPageChange(page: number) {
    this.page.setPageNumber(page - 1);
    this.search();
  }

  openDetail(libro: Libro) {
    this.selectedLibro = libro;
    this.view = "detail";
  }

  backToList() {
    this.view = "list";
  }

  beforeMount() {
    console.log(`UI v. ${packageInfo.version}`);
    this.onSearchChange(new LibriSearchRequest());
  }
}
